import { BarTrendChart, Panel } from '@bcecloud/portal-ui';
import { compactMoney, shortMonth, type RepScore, type SalesScorecard } from '@/lib/sales';

/**
 * The 12-month booked-revenue chart, stacked by rep with every other owner
 * folded into Other.
 */
export function RevenueTrend({
  scorecard,
  reps,
  title,
}: {
  readonly scorecard: SalesScorecard;
  readonly reps: readonly RepScore[];
  readonly title: string;
}): React.ReactElement {
  const months = scorecard.team.trend.map((point) => point.month);
  const repSeries = reps.map((rep) => ({
    key: rep.ownerName,
    label: rep.ownerName,
    values: rep.trend.map((point) => point.revenue),
  }));
  const showOther = reps.length === scorecard.reps.length;
  const series = showOther
    ? [...repSeries, { key: 'Other', label: 'Other owners', values: scorecard.team.otherTrend.map((point) => point.revenue) }]
    : repSeries;
  const points = months.map((month, index) => ({
    key: month,
    label: shortMonth(month),
    value: series.reduce((sum, entry) => sum + (entry.values[index] ?? 0), 0),
  }));
  return (
    <Panel className="p-5">
      <h2 className="text-portal-card-title font-bold text-portal-ink">{title}</h2>
      <p className="text-portal-micro text-portal-muted">
        Contract value of won deals (Contract Signed and Signed - Postponed), by the month they were signed.
      </p>
      <BarTrendChart
        className="mt-4"
        title={title}
        unit="booked"
        points={points}
        series={series}
        height={280}
        formatValue={compactMoney}
      />
    </Panel>
  );
}
